<template>
  <router-view v-if="displayRouterView" :pageType="componentName"></router-view>
  <component v-else :is="componentName" :model="model" />
</template>
<script>
import { VacancyModes } from '../../../models/enums'
import VacancyDetails from './ContentType.VacancyDetails.vue'
import VacancyList from './ContentType.VacancyList.vue'

export default {
  name: 'Vacancy',
  components: {
    VacancyDetails,
    VacancyList
  },
  props: {
    model: {
      type: Object
    }
  },
  computed: {
    displayRouterView: function () {
      return this.model.metadata.mode === VacancyModes.Details
    },
    componentName: function () {
      var name
      switch (this.model.metadata.mode) {
        case VacancyModes.Details:
          name = 'vacancy-details'
          break
        default:
          name = 'vacancy-list'
          break
      }
      return name
    }
  }
}
</script>
